<template>
  <div class="streak-and-goal-container grid-row">
    <widget-card>
      <streak-widget
        :flashcard-stats="flashcardStats"
        :streak-info-body="streakInfoBody"
      ></streak-widget>
    </widget-card>
    <widget-card>
      <goal-widget
        :flashcard-stats="flashcardStats"
      ></goal-widget>
    </widget-card>
  </div>
</template>

<script>
import StreakWidget from './StreakWidget.vue';
import GoalWidget from './GoalWidget.vue';
import WidgetCard from './WidgetCard.vue';
import WidgetMixin from '@/mixins/widget';

export default {
  name: 'StreakAndGoalWidget',
  components: {
    GoalWidget,
    StreakWidget,
    WidgetCard,
  },
  mixins: [WidgetMixin],
  props: {
    config: {
      type: Object,
      required: true,
    },
    dashboard: {
      type: Object,
      required: true,
    },
    identifier: {
      type: Number,
      required: true,
    },
  },
  computed: {
    flashcardStats() {
      const stats = this.$store.getters['flashcardStates/flashcardStats']?.flashcard || [];
      return this.sortStats([...stats]);
    },
    streakInfoBody() {
      return this.config.config?.streakInfoBody;
    },
  },
  methods: {
    sortStats(stats) {
      return stats.sort((a, b) => new Date(b.date) - new Date(a.date));
    },
  },
};
</script>

<style scoped lang="scss">
.streak-and-goal-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: rem-calc(24);

  /deep/ .header-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: rem-calc(16);
    font-weight: 600;
    line-height: rem-calc(24);
    gap: 6px;
    margin-bottom: rem-calc(16);
  }

  /deep/ .spacer {
    flex: 1;
  }

  /deep/ .icon-wrapper {
  transform: translateY(2px);
  }

  /deep/ .hero {
    font-size: rem-calc(30);
    font-weight: 600;
    line-height: rem-calc(38);
  }
}
</style>
